import React from 'react';

const AgentLocationIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2190_28975"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-1"
        width="18"
        height="18"
      >
        <rect x="-0.5" y="-0.5" width="17" height="17" fill="#D9D9D9" stroke="#FEE7CC" />
      </mask>
      <g mask="url(#mask0_2190_28975)">
        <path
          d="M3.50908 9.25262L3.50905 9.25258L3.50297 9.25573C3.09786 9.46527 2.77245 9.77096 2.5316 10.1632C2.28798 10.56 2.16602 10.998 2.16602 11.4665V11.9998C2.16602 12.5002 2.35 12.9409 2.70413 13.2951C3.05826 13.6492 3.49902 13.8332 3.99935 13.8332H11.9993C12.4997 13.8332 12.9404 13.6492 13.2946 13.2951C13.6487 12.9409 13.8327 12.5002 13.8327 11.9998V11.4665C13.8327 10.998 13.7107 10.56 13.4671 10.1632C13.2262 9.77096 12.9008 9.46527 12.4957 9.25573L12.4957 9.25569L12.4896 9.25262C11.7688 8.8922 11.0333 8.62044 10.2837 8.43889C9.94313 8.3564 9.60007 8.29265 9.25462 8.24763C9.61207 8.09238 9.94028 7.86601 10.2362 7.57006C10.8515 6.95481 11.166 6.20017 11.166 5.33317C11.166 4.46617 10.8515 3.71153 10.2362 3.09628C9.62099 2.48104 8.86634 2.1665 7.99935 2.1665C7.13235 2.1665 6.3777 2.48104 5.76246 3.09628C5.14722 3.71153 4.83268 4.46617 4.83268 5.33317C4.83268 6.20017 5.14722 6.95481 5.76246 7.57006C6.05841 7.86601 6.38662 8.09238 6.74408 8.24763C6.39863 8.29265 6.05557 8.3564 5.71499 8.43889C4.96535 8.62044 4.22993 8.8922 3.50908 9.25262Z"
          fill="#FA9E33"
          stroke="#C76B00"
        />
      </g>
    </svg>
  );
};

export default AgentLocationIcon;
